import React from 'react';

export const StaticContext = React.createContext();
export const StaticProvider = StaticContext.Provider;
export const StaticConsumer = StaticContext.Consumer;
